import type { ReactNode } from "react";
import { Link, useLocation } from "react-router-dom";

export type PageHeaderProps = {
  eyebrow?: ReactNode;
  title: ReactNode;
  intro?: ReactNode;
};

const ROUTE_LABELS: Record<string, string> = {
  about: "About Us",
  join: "Join Our Club",
  training: "Training",
  contact: "Contact",
};

function Breadcrumbs() {
  const { pathname } = useLocation();
  const segments = pathname.split("/").filter(Boolean);
  if (segments.length === 0) return null;

  const label = ROUTE_LABELS[segments[0]] ?? segments[0];

  return (
    <nav
      aria-label="Breadcrumb"
      className="hidden lg:block mt-8"
    >
      <ol className="flex items-center gap-2 text-xs uppercase tracking-widest list-none p-0 m-0">
        <li>
          <Link
            to="/"
            className="no-underline transition-colors hover:text-white"
            style={{ color: "rgba(255,255,255,0.5)" }}
          >
            Home
          </Link>
        </li>
        <li aria-hidden="true" style={{ color: "rgba(255,255,255,0.3)" }}>/</li>
        <li>
          <span style={{ color: "rgba(255,255,255,0.8)" }}>{label}</span>
        </li>
      </ol>
    </nav>
  );
}

export function PageHeader({ eyebrow, title, intro }: PageHeaderProps) {
  return (
    <section
      className="relative texture-dark"
      style={{ backgroundColor: "#0a0a0a", color: "#fff" }}
    >
      <div className="container-page py-14 sm:py-18 lg:py-22">
        <div className="grid lg:grid-cols-2 gap-6 items-end">
          <div>
            {eyebrow ? <p className="eyebrow">{eyebrow}</p> : null}
            <h1 className="mt-2">{title}</h1>
          </div>
          {intro ? (
            <div className="flex flex-col gap-4 lg:items-end">
              <p
                className="text-base sm:text-lg leading-relaxed lg:text-right max-w-[36ch]"
                style={{ color: "rgba(255,255,255,0.7)" }}
              >
                {intro}
              </p>
              <span
                aria-hidden="true"
                className="block w-16 h-[2px]"
                style={{ backgroundColor: "#d71920" }}
              />
            </div>
          ) : null}
        </div>
        <Breadcrumbs />
      </div>
      <div
        aria-hidden="true"
        className="absolute bottom-0 left-0 right-0"
        style={{ height: 3, backgroundColor: "#d71920" }}
      />
    </section>
  );
}
